import React from 'react';
import {
  Box,
  Collapse,
  List,
  Typography,
} from '@mui/material';
import { BurgerNav } from '../../icons/burger-nav';
import { style } from './style';
import { NavItem } from './NavItem';
// import { NavItem } from './NavItem';

type NavigationProps = {
  title: string,
  navList: NavItemProps[],
  onOpenNavClick: () => void,
  isOpenNav: boolean,
}

export const Navigation = (
  {
    title,
    navList,
    onOpenNavClick,
    isOpenNav,
  }
  :NavigationProps):JSX.Element => {
  return (
    <List sx={ style.boxContainer }>
      <Box
        sx={ { ...style.menuList.btn.box.sx, ...style.menuList.btn.burger.sx(isOpenNav) } }
        onClick={ onOpenNavClick }
      >
        <BurgerNav style={ { ...style.menuList.btn.sx, ...style.boxSvg.sx } } />
      </Box>
      <Collapse in={ isOpenNav }>
        <List sx={ style.menuList.sx }>
          <Typography
            variant="overline"
            color={ style.menuList.typography.sx.color }
            style={ style.menuList.title.font }
            sx={ style.boxListContainer.sx }
          >
            { title }
          </Typography>
          { navList.map((nav: NavItemProps) => {
            return (
              <NavItem
                key={ nav.title }
                title={ nav.title }
                icon={ nav.icon }
                counter={ nav.counter }
                hash={ nav.hash }
                isError={ nav.isError }
              />
            );
          }) }
        </List>
      </Collapse>
    </List>
  );
};
